// Vendor imports
const Immutable = require('immutable')

function defaultReviver(key, seq) {
  return Immutable.isKeyed(seq) ? Immutable.Map(seq) : Immutable.List(seq)
}

function nestedReviver(reviver) {
  return function (key, seq, keyPath) {
    if (keyPath.length === 1) {
      return reviver.call(this, '', seq, [])
    }
    return reviver.call(this, key, seq, keyPath.slice(1))
  }
}

function keyedReviver(containerType, reviversByKey) {
  const nestedReviversByKey = Object.keys(reviversByKey)
  .reduce((acc, key) => {
    acc[key] = nestedReviver(reviversByKey[key])
    return acc
  }, {})
  return function (key, seq, keyPath) {
    if (keyPath.length === 0) {
      return new containerType(seq)
    }
    const reviver = nestedReviversByKey[keyPath[0]]
    if (reviver) {
      return reviver.call(this, key, seq, keyPath)
    }
    return defaultReviver.call(this, key, seq, keyPath)
  }
}

function listReviver(itemReviver) {
  const reviver = nestedReviver(itemReviver)
  return function (key, seq, keyPath) {
    if (keyPath.length === 0) {
      return new Immutable.List(seq)
    }
    return reviver.call(this, key, seq, keyPath)
  }
}

module.exports = {
  defaultReviver,
  keyedReviver,
  listReviver
}
